export default "__VITE_ASSET__tFBl$Kca__"